<header class="header">
  <div class="header__content">
    <div class="header__logo">
      <a href="/" class="header__logo-link">
        <img
          ngSrc="assets/logo.svg"
          height="35"
          width="35"
          [alt]="appName()"
          priority
        />
      </a>
      <a href="/" class="header__title-link">{{ appName() }}</a>
    </div>
    <nav class="header__nav">
      @if (user()) {
        <a
          [href]="'/' + paths()['PROFILE']"
          class="header__nav-link profile-link"
        >
          @if (user()!.avatarPath) {
            <img
              [ngSrc]="user()!.avatarPath! | imageUrl"
              width="32"
              height="32"
              class="header__avatar"
              alt="User avatar"
            />
          }
          <span class="header__username">{{ user()!.username }}</span>
        </a>
      } @else {
        <a [href]="'/' + paths()['LOGIN']" class="header__nav-link">Login</a>
        <a [href]="'/' + paths()['REGISTER']" class="header__nav-link"
          >Register</a
        >
      }
      <button
        class="header__menu-trigger"
        [matMenuTriggerFor]="headerMenu"
        aria-label="More options"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
    </nav>
  </div>
</header>

<mat-menu #headerMenu="matMenu">
  <a mat-menu-item href="/privacy-policy">Privacy policy</a>
  <button mat-menu-item (click)="leaveFeedback.emit()">Leave feedback</button>
</mat-menu>
